<div>
  {{xml()}}
</div>
